import "../polyfills";
import Postmate from "postmate";
import iframeResizer from "iframe-resizer/js/iframeResizer";
import URLParams from "../utils/URLParams";

export default function ArmaxPayForm(params) {
  var terminalId = params.terminalId;
  var container = params.container;
  var mountedCb = params.mounted;
  // Для режима отображения только одного провайдера,
  // без общего списка
  var singleProviderId = params.providerId;

  var iFrameDomain = process.env.IFRAME_DOMAIN;
  var iFrameURL = process.env.IFRAME_URL;
  var iFrameID = "armax-pay-widget-frame";

  var self = this;

  this.terminalId = terminalId;
  this.singleProviderId = singleProviderId;
  this.URLParams = new URLParams(window.location);

  this._injectCSS({
    element: "#" + container.id + " > iframe",
    css:
      "background-color: transparent; width: 100%; min-height: 100px; border: 0",
  });

  var handshake = new Postmate({
    container: container,
    url: iFrameURL,
    // в текущей версии Postmate (1.5.2) ломается IE 11 без classListArray
    // см. https://github.com/dollarshaveclub/postmate/issues/207
    classListArray: ["pw"],
  });

  handshake.then(function initHandshake(iframe) {
    iframe.frame.id = iFrameID;

    iframeResizer({ checkOrigin: [iFrameDomain] }, "#" + iFrameID);

    if (self.URLParams.has("checkNumber")) {
      self._checkPayStatus(iframe);
      return;
    }

    iframe.call("initPaymentParams", {
      terminalId: terminalId,
      singleProviderId: singleProviderId,
      returnUrl: self._createReturnUrl(),
      providerData: self._getProviderData(),
    });

    iframe.on("payment:redirect", function paymentRedirectIframe(url) {
      window.location.replace(url);
    });

    iframe.on("router:clearHash", function paymentClearURLHash() {
      window.location.hash = "";
    });

    iframe.on("app:mounted", function appMounted(url) {
      var self = this;

      var view = {
        toMain: function () {
          self.call("viewToMain");
        },
      };
      mountedCb && mountedCb({ view: view, terminalId: terminalId });
    });
  });
}

ArmaxPayForm.prototype._createReturnUrl = function ArmaxPayFormCreateReturnUrl() {
  return {
    origin: window.location.origin,
    pathname: window.location.pathname,
    search: window.location.search,
  };
};

ArmaxPayForm.prototype._checkPayStatus = function ArmaxPayFormCheckPayStatus(
  iframe
) {
  var self = this;
  var terminalId = this.terminalId;
  var singleProviderId = this.singleProviderId;
  var checkNumber = this.URLParams.get("checkNumber");

  iframe.on("payment:redirect", function paymentRedirectIframe(url) {
    window.location.replace(url);
  });

  iframe.on("router:clearUrlParams", function paymentClearUrlParams() {
    window.location.search = "";
  });

  iframe.call("getPayStatus", {
    terminalId: terminalId,
    singleProviderId: singleProviderId,
    checkNumber: checkNumber,
    returnUrl: self._createReturnUrl(),
  });
};

ArmaxPayForm.prototype._injectCSS = function ArmaxPayFormInjectCSS(params) {
  var element = params.element;
  var css = params.css;
  var cssStyle = element + "{" + css + "}";

  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";

  if (style.styleSheet) {
    style.styleSheet.cssText = cssStyle;
  } else {
    style.appendChild(document.createTextNode(cssStyle));
  }

  head.appendChild(style);
};

ArmaxPayForm.prototype._getProviderData = function ArmaxPayFormGetProviderData() {
  var hash = window.location.hash;
  if (this.singleProviderId) return "/provider/" + this.singleProviderId;

  if (hash.indexOf("#/provider/") === -1) {
    return null;
  }
  return hash.slice(1);
};
